import React from "react";
import { createPortal } from "react-dom";
import SpDownloadButtons from "../SpDownloadButtons/SpDownloadButtons";
import "./SpAppPromptModal.scss";

const SpAppPromptModal = ({ isOpen, onClose, serviceName }) => {
    if (!isOpen) return null;

    return createPortal(
        <div className="sp-app-prompt__overlay" onClick={onClose}>
            <div className="sp-app-prompt" onClick={(e) => e.stopPropagation()}>
                <button className="sp-app-prompt__close" onClick={onClose}>✕</button>
                <div className="sp-app-prompt__icon">📱</div>
                <h3 className="sp-app-prompt__title">Get the full experience on our app</h3>
                <p className="sp-app-prompt__desc">
                    <strong>{serviceName}</strong> is available on the Sapa mobile app. Download it to access all our services.
                </p>
                <SpDownloadButtons />
            </div>
        </div>,
        document.body
    );
};

export default SpAppPromptModal;